import { Box } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import styles from "../../../DesignEditor/styles/GraphicEditor.module.scss";
import LoadingPlaceholder from "../../../components/common/LoadingPlaceholder/LoadingPlaceholder.tsx";
import RouterConstants from "../../../constants/RouterConstants.ts";
import { useAppStore } from "../../../hooks/useStores.tsx";
import { isAdsEditor } from "../../../utils/index.ts";
import { PopUpSteps } from "../../constants/mock-data.ts";
import CampaignWorkspace from "./components/CampaignWizard/CampaignWorkspace/CampaignWorkspace.tsx";
import Canvas from "./components/Canvas";
import AdsEditorHeader from "./components/DesignEditorV2/AdsEditorHeader/AdsEditorHeader.tsx";
import AdsEmptyState from "./components/DesignEditorV2/AdsEmptyState/AdsEmptyState.tsx";
import EditorContainer from "./components/EditorContainer";
import Footer from "./components/Footer";
import Panels from "./components/Panels";
import TemplatesCreationGuideSection from "./components/TemplatesCreationGuideSection/TemplatesCreationGuideSection.tsx";
import Toolbox from "./components/Toolbox";

function GraphicEditor(props: { isPopup?: boolean }) {
	const { designEditorStore, campaignStore } = useAppStore();
	const SMART_IMAGE_INDEX = PopUpSteps.indexOf("images");
	const WIZARD_IMAGE_INDEX = PopUpSteps.indexOf("WizardImages");
	useEffect(() => {
		return () => {
			if (
				designEditorStore.activeStep !== SMART_IMAGE_INDEX &&
				designEditorStore.activeStep !== WIZARD_IMAGE_INDEX
			)
				designEditorStore.resetCampaignPopup();
		};
	}, []);

	return (
		<>
			<EditorContainer>
				{props.isPopup ? (
					<CampaignWorkspace />
				) : (
					<>
						{/*<Navbar />*/}
						<Box component="div" className={styles.graphicContainer}>
							<Panels />

							<>
								{!campaignStore.selectedTemplate && (
									<Box
										className={clsx({
											[styles.adsEditorEmptyStateContainer]: true,
											[styles.hide]: campaignStore.selectedTemplate,
										})}
									>
										<AdsEditorHeader />
										<LoadingPlaceholder
											className={styles.loadingPlaceholder}
											isLoading={isAdsEditor() && campaignStore.isLoadingScenesInAdsEditor}
										>
											<AdsEmptyState
												isTemplatesAndBrandsMode={location.pathname.startsWith(
													RouterConstants.ADS_GENERATION.DEMO.BRANDS_TEMPLATES_EDITOR
														.fullPath,
												)}
											/>
										</LoadingPlaceholder>
									</Box>
								)}

								<Box
									component="div"
									className={clsx({
										[styles.graphicSubContainer]: true,
										[styles.hide]: !campaignStore.selectedTemplate,
									})}
								>
									<AdsEditorHeader />
									<Toolbox />
									<Canvas />
									<Footer />
								</Box>
							</>
							<TemplatesCreationGuideSection />
						</Box>
					</>
				)}
			</EditorContainer>
		</>
	);
}

const ObservedComponent = observer(GraphicEditor);
export default ObservedComponent;
